import { ArticleArea } from "../../../Styling/Layout/ContentArea"
import { Container, Col, Form } from "react-bootstrap";
import { BfButtonBlue, BfFormControl, BfFormLabel, BfTightYellowRowForm, BfYellowRowForm, YellowRoundedContainer } from "../../../Styling/styledForm/styledBlueForm";
import { useState } from "react";

export const ValidateSMSCode = (props) => {

    let messages = props.messages
    const postValidationCode= props.postValidationCode
    
    const [mfaCode, setMfaCode] = useState('')
    const submitHandler = e => {
        e.preventDefault()
        postValidationCode(mfaCode)
    }

    return (

        <YellowRoundedContainer fluid="md">

            <Form autoComplete="off" onSubmit={submitHandler}>
                <Container >

                    <ArticleArea>
                        <h1>{messages.DisplaySendSMSCodeHeader}</h1>
                        <p>{messages.DisplaySendSMSCodeParagraph}</p>
                    </ArticleArea>            

                    <BfYellowRowForm>
                        <Col xs={12} md={12}>
                            <Form.Group controlId="formHorizontalEmail">
                                
                                <BfFormLabel>{messages.SMSKode}</BfFormLabel>

                                <BfFormControl
                                    className="col-md2"
                                    type="input"
                                    placeholder=""
                                    name="smskode"
                                    value={mfaCode}
                                    onChange={(event) => setMfaCode(event.target.value)}
                                />
                                
                            </Form.Group>
                        </Col>
                    </BfYellowRowForm>

                    <BfTightYellowRowForm>
                        <Col xs={12} md={12}>
                            <BfButtonBlue variant="primary" type="submit" disabled={!mfaCode}>
                                {messages.RegistrerSMSKode}
                            </BfButtonBlue>
                        </Col>
                    </BfTightYellowRowForm>

                    <BfTightYellowRowForm />

                </Container>

            </Form>


        </YellowRoundedContainer>

    )
}